import React from 'react';
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {EditorHeader} from "../header/editorHeader";
import {EditorContent} from "../content/editorContent";
import {Box} from "@mui/material";
import {PageSpinner} from "../../com/pagesTab/pagesSpinner/spinner";

export const Main = () => {
    const storeState = useTypedSelector((state) => state.storeForAccount);

    return (
        <>
            <EditorHeader/>
            <EditorContent/>
            {storeState.loading &&
                <Box sx={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 2,
                    opacity: "0.7",
                    backgroundColor: "#D4DADE"
                }}>
                    <PageSpinner/>
                </Box>}
        </>
    )
}